let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ffRdF")).then(() => parcelRequire('1nf4f'));